/**
 * Dependencies
 */
import { getState } from './state'

const CREATE_NEW_RENT_COMP = (state, data) => {
    state.data.push(data)
}

const DELETE_RENT_COMP = (state, data) => {
    state.data.splice(data.index, 1)
}

const FETCH_RENT_COMPS = (state, data) => {
    state.data = data.data
}

const RESET_STATE = state => {
    Object.assign(state, getState())
}

const SET_LOADING = state => {
    state.loading = true
}

const RESET_LOADING = state => {
    state.loading = false
}

const SET_ERROR = state => {
    state.error = true
}

const RESET_ERROR = state => {
    state.error = false
}

const SET_OPTIONS = (state, data) => {
    state.options = data
}

const SELECT_OPTION = (state, option) => {
    state.selected = option
}

export default {
    FETCH_RENT_COMPS,
    CREATE_NEW_RENT_COMP,
    DELETE_RENT_COMP,
    SET_LOADING,
    RESET_LOADING,
    SET_ERROR,
    RESET_ERROR,
    RESET_STATE,
    SET_OPTIONS,
    SELECT_OPTION
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-compset/mutations.js